import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import ServerTable from "../../../lib/ServerTable";
import DateRangePicker from "../../../lib/DateRangePicker";
import getVehicleColums from "./columns/VehicleColumns";
import { useAuth, useApiDelete, useBasepathUrl } from "../../../hooks";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";

import "../../../common/css/DateRangePicker.css";

const formInitailData = {
    vehicleId: null,
  };

export default function VehicleDetails() {

  const navigate = useNavigate();
  const location = useLocation();
  const basePage = useBasepathUrl(1);

  const roleKey = localStorage.getItem("roleKey");
  const entityId = localStorage.getItem("entityId");
  if(roleKey === 'bunk_incharge' && entityId == "") {
      navigate('/');
  }

  const [viewDetails] = useState(() => {
    try {
      const data = localStorage.getItem('view_details');
      return data ? JSON.parse(data) : null;
    } catch {
      return null;
    }
  });

   const [formData, setFormData] = useState(() => ({
    ...formInitailData,
    vehicleId: viewDetails?.vehicleId ?? null,
  }));

  const [showConfirm, setShowConfirm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showFilder, setShowFilder] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [selectedRowId, setSelectedRowId] = useState('');
  const [customSearch, setCustomSearch] = useState('');
  const [isDeleted, setIsDeleted] = useState(false);
  const [searchObjVal, setSearchObjVal] = useState('');
  const [customerror, setCustomerror] = useState('');
  const [selectedDateRange, setSelectedDateRange] = useState({startDate: '',endDate: ''});
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
    console.log('viewDetails', viewDetails);
    if (!viewDetails || Object.keys(viewDetails).length === 0) {
      navigate('/vehicle', { replace: true });
    }

  }, [viewDetails, navigate]);


  useEffect(() => {
    return () => {
      if (window.location.pathname !== '/vehicle/detail') {
        localStorage.removeItem('view_details');
      }
    };
  }, []);


    useEffect(() => {
      const searchObj = {};
      let filterTxt = '';
      if(roleKey === 'bunk_incharge') {
          filterTxt = 'entityId|'+entityId;
      }
      if(selectedDateRange?.startDate  && selectedDateRange?.endDate) {
        let startDateTxt = selectedDateRange?.startDate+' 00:00:00';
        let endDateTxt = selectedDateRange?.endDate+' 23:59:59';
        let dateRngTxt = 'startTime|'+startDateTxt+'&endTime|'+endDateTxt;
        filterTxt = (filterTxt)?filterTxt+'&'+dateRngTxt:dateRngTxt;
      }

      if(formData.vehicleId != null && formData.vehicleId != "") {
        filterTxt = (filterTxt)?filterTxt+'&vehicleId|'+formData.vehicleId:'vehicleId|'+formData.vehicleId;
      }

      if(filterTxt != "") {
        searchObj.filter = filterTxt;
      }

      setSearchObjVal(searchObj);
      setTableKey(prev => prev + 1);
  }, [
    selectedDateRange?.startDate,
    selectedDateRange?.endDate,
    formData.vehicleId
  ]);

  const handleDateRangeApply = (dateRange) => {
    console.log('Received dates:', dateRange);
    setSelectedDateRange(dateRange);
  };
   
  const handleDelete = (roleId) => {
        setShowConfirm(true);
        setSelectedRowId(roleId);
  };

  const handleViewDetail = (rowDetails) => {
       
  };

  const handleCancel = () => {
    setShowConfirm(false);
    setSelectedRowId('');
  };

  const handleDetailCancel = () => {
    setShowDetails(false);
    setRowData([]);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };


  const columns = getVehicleColums('detail', handleDelete, handleViewDetail);

  const handleChange = (selectedOption, actionMeta) => {
    setFormData(prev => ({
      ...prev,
      [actionMeta.name]: selectedOption
    }));
  };

  const goBackToMain = () => {
          navigate(basePage);
  }

  return (<div className="vehicle-detailmain-page">
          <Container fluid>
            <div className='innerpage-breadcrumb-main'>
              <ul className='breadcrumb-ul'> <li onClick={() => goBackToMain()}>Vehicle Management</li><li>Vehicle Details</li> </ul>
            </div> 
            <div className='page-content-main'>
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}
              

              <Card className='card-nobarder mb-2 p-1'>
                    <CardBody>

                        <div className='vehiclebasic-info-main'>
                            <div className='modalview-info-maindiv'>
                              <div className='modalview-info-flx-row'>
                                    <div className='modalview-info-col'>
                                          <div className='modalview-info-lable'>Vehicle No. & Type</div>
                                          <div className='modalview-info-val'>
                                            {viewDetails?.vehicleNo} {' '}
                                            {viewDetails?.type === 'Bike' && (
                                            <span className="vehicle-type1">Bike</span>
                                            )}
                                            {viewDetails?.type === 'Car' && (
                                            <span className="vehicle-type2">Car</span>
                                            )}
                                            {viewDetails?.type === 'Truck' && (
                                            <span className="vehicle-type3">Truck</span>
                                            )}
                                            </div>
                                    </div>
                                    <div className='modalview-info-col'>
                                          <div className='modalview-info-lable'>Vehicle Model</div>
                                          <div className='modalview-info-val'>{viewDetails?.model}</div>
                                    </div>
                                    <div className='modalview-info-col'>
                                          <div className='modalview-info-lable'>Vehicle Owner Name</div>
                                          <div className='modalview-info-val'>{viewDetails?.ownerName}</div>
                                    </div>
                                    <div className='modalview-info-col'>
                                          <div className='modalview-info-lable'>Total Purchase Fuel</div>
                                          <div className='modalview-info-val'>{viewDetails?.totalLitres} litres</div>
                                    </div>
                                    <div className='modalview-info-col'>
                                          <div className='modalview-info-lable'>Total Purchase Value</div>
                                          <div className='modalview-info-val'>₹ {viewDetails?.totalAmount}</div>
                                    </div>
                              </div>
                            </div>
                      </div>


                       <div className='filter-action-main'>
                            <Row className="mb-2">
                                <Col xs={12} sm={6} md={10}>
                                    <div className='input-filter-action'>
                                        <input type="text" id="customSearch" name='customSearch' placeholder="Search by vehicle number & vehicle type" value={customSearch} onChange={handleSearchChange} />
                                    </div>
                                </Col>
                                <Col xs={12} sm={6} md={2} className='apply-mgtp-mbl'>
                                    <div className='daterangepicker-maincls'>
                                      <DateRangePicker onApply={handleDateRangeApply} />
                                    </div>
                                </Col>
                            </Row>
                      </div>

                      <Row>
                        <Col xs="12">
                              <div className='tablelist-maindiv'>
                                  <ServerTable
                                    key={tableKey}
                                    apiUrlTxt="vehicle-activities"
                                    columns={columns}
                                    customParams={searchObjVal}
                                    showSearch={false}
                                    showAddBtn={false}
                                    addBtn={{ label: '', url: `` }}
                                    srlNumbr={false}
                                    customSearch={true}
                                    customSearchTxt={customSearch}
                                  />
                              </div>
                        
                        </Col>
                      </Row>

                    </CardBody>
              </Card>      


            </div>   
          </Container>
        </div>);
}
